import React, { FC } from 'react';
import theme from '@buoyhealth/common.buoy-theme';

type PillBottleIconProps = {
  className?: string;
  color?: string;
};

const PillBottleIcon: FC<PillBottleIconProps> = ({
  className = '',
  color = theme.palette.primary.main,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <rect x="6.30859" y="1" width="10.3846" height="4.61538" rx="1" fill={color} />
    <rect
      x="4.75"
      y="6.36536"
      width="13.5"
      height="15.8077"
      rx="1.25"
      stroke={color}
      strokeWidth="1.5"
    />
    <rect x="9.76953" y="10.2307" width="8.07692" height="8.07692" fill={color} />
  </svg>
);

export default PillBottleIcon;
